export function init($name = '') {
    const button = $($name);

    if (!button.length) {
        return;
    }

    button.click(function(e) {
        e.preventDefault();
        const parent = $(this).parents('section.section');
        const content = parent.find('.cont');
        const map = parent.find('.google-map');
        const form = parent.find('.form--hld');

        parent.toggleClass('is-showing-form');

        if (parent.hasClass('is-showing-form')) {
            map.css('min-height', map.height());
            content.fadeOut(function () {
                form.fadeIn();
            });
        } else {
            form.fadeOut(function () {
                content.fadeIn();
            });
        }
    });
}
